const VIEW_HUB = 'hub';
const VIEW_ACCOUNT_DETAILS = 'account-details';
const VIEW_LOGIN_SECURITY = 'login-security';
const VIEW_CHANGE_PASSWORD = 'change-password';

export {
  VIEW_HUB,
  VIEW_ACCOUNT_DETAILS,
  VIEW_LOGIN_SECURITY,
  VIEW_CHANGE_PASSWORD,
};
